import script from "./stage-subject-grade.vue?vue&type=script&setup=true&lang=js"
export * from "./stage-subject-grade.vue?vue&type=script&setup=true&lang=js"

import "./stage-subject-grade.vue?vue&type=style&index=0&id=01ccecdc&lang=scss"
import "./stage-subject-grade.vue?vue&type=style&index=1&id=01ccecdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ccecdc"]])

export default __exports__